/**
 * The rank of an employee.
 */
export enum EmployeeRankEnum {
  /** The less experienced employee. */
  Rank_1 = 'RANK_1',

  /** The more experienced employee. */
  Rank_2 = 'RANK_2'
}

/**
 * Returns list of all {@link EmployeeRankEnum} values.
 */
export function rankValues(): EmployeeRankEnum[] {
  return Object.values(EmployeeRankEnum).map((rank: Extract<typeof EmployeeRankEnum, string>) => rank);
}
